module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Lamp#1-34764ad7ecc51e24aeab469597ae354f.svg";